// ViewPointModal.js
import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import '../../style/ViewPointModal.css';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const ViewPointModal = ({ point, onClose }) => {
    return (
        <div className="modal">
            <div className="modal-content">
                <button className="close-button" onClick={onClose}>×</button>
                <h2>{point.name}</h2>
                <p>Адрес: {point.address}</p>
                <p>Телефон: {point.phone}</p>
                <MapContainer center={[point.latitude, point.longitude]} zoom={15} style={{ height: "300px", width: "100%" }}>
                    <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    />
                    <Marker position={[point.latitude, point.longitude]}>
                        <Popup>
                            {point.name} <br /> {point.address}
                        </Popup>
                    </Marker>
                </MapContainer>
            </div>
        </div>
    );
};

export default ViewPointModal;
